// Конвертація HTML-розмітки тікету (опис, повідомлення чату) у Markdown.
// Зображення витягуються в спільний масив images для подальшого архівування.

// Розбирає data-URI зображення (data:image/png;base64,....)
function parseDataUri(src){
    let match = /^data:(image\/[a-zA-Z0-9.+-]+);base64,(.*)$/i.exec(src);
    if(!match){
        return null;
    }
    return { mime: match[1], base64: match[2] };
}

// Визначає розширення файлу по mime-типу
function extFromMime(mime){
    let map = {
        "image/png": "png",
        "image/jpeg": "jpg",
        "image/jpg": "jpg",
        "image/gif": "gif",
        "image/webp": "webp",
        "image/svg+xml": "svg",
        "image/bmp": "bmp"
    };
    return map[(mime || "").toLowerCase()] || "png";
}

// Визначає розширення зображення за його src (data-URI або звичайне посилання)
function extFromSrc(src, dataUri){
    if(dataUri){
        return extFromMime(dataUri.mime);
    }
    let m = /\.(png|jpe?g|gif|webp|svg|bmp)(?:\?|$)/i.exec(src);
    if(m){
        return m[1].toLowerCase() === "jpeg" ? "jpg" : m[1].toLowerCase();
    }
    return "png";
}

// Перетворює HTML в Markdown:
// - зображення замінює на посилання за іменем (![image-N](images/image-N.ext)),
//   а самі зображення збирає в масив images для подальшого архівування
// - зберігає переноси рядків та абзаци
function htmlToMarkdown(html, images){
    if(!html){
        return "";
    }

    let md = html;

    // зображення -> markdown-посилання за іменем файлу
    md = md.replace(/<img[^>]*?src="([^"]*)"[^>]*?>/gi, (match, src) => {
        let index = images.length + 1;
        let dataUri = parseDataUri(src);
        let ext = extFromSrc(src, dataUri);

        let filename = `image-${index}.${ext}`;
        images.push({ filename, src, dataUri });

        return `\n\n![${filename}](images/${filename})\n\n`;
    });

    // переноси рядків та абзаци
    md = md.replace(/<br\s*\/?>/gi, "\n");
    md = md.replace(/<\/p>/gi, "\n\n");

    // прибираємо інші HTML-теги
    md = md.replace(/<[^>]*>/g, "");

    // декодуємо базові HTML-сутності
    md = md
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'");

    // прибираємо зайві порожні рядки
    md = md.replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();

    return md;
}

export { htmlToMarkdown };
